<template>
  <div>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div class="tableContainerDetails">
      <f7-row class="card-body">
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('agronomySample.summary.sampleCode') }}
              </div>
              <div class="item-title-bold value-text">
                {{ currentSampleSummary.code }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('agronomySample.summary.sampleType') }}
              </div>
              <div class="item-title-bold value-text">
                {{ currentSampleSummary.sample_type }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col>
          <f7-row>
            <f7-col>
              <div></div>
              <div class="item-title-bold value-text"></div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('foodSamples.receptionDate') }}
              </div>
              <div class="item-title-bold value-text">
                {{
                  $dates.formatDateDayMonthYear(
                    currentSampleSummary.reception_date
                  )
                }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col>
          <f7-row>
            <f7-col>
              <f7-row>
                <f7-col style="text-align: right">
                  <!-- <ContextMenu
                    :id="'btnDownloadFoodDetails'"
                    :items="items"
                  /> -->
                  <!-- <DxButton
                    id="btnDownloadFoodDetails"
                    type="normal"
                    styling-mode="outlined"
                  >
                    <i class="" style="cursor: pointer">
                      <img
                        width="45"
                        height="30"
                        :src="getIconPath"
                        alt="download"
                      />

                      <DxContextMenu
                        :data-source="items"
                        target="#btnDownloadFoodDetails"
                        show-event="dxclick"
                      />
                    </i>
                  </DxButton> -->
                </f7-col>
              </f7-row>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>

      <f7-row class="card-body">
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('agronomySample.summary.description') }}
              </div>
              <div class="item-title-bold value-text">
                {{ currentSampleSummary.sample_name }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('environmentSamples.summary.project') }}
              </div>
              <div class="item-title-bold value-text">
                {{ currentSampleSummary.study }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>

        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('environmentSamples.installation') }}
              </div>
              <div class="item-title-bold value-text">
                {{ currentSampleSummary.farm }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('environmentSamples.samplingPoint') }}
              </div>
              <div class="item-title-bold value-text">
                {{ currentSampleSummary.parcel }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('agronomySample.summary.status') }}
              </div>
              <div class="item-title-bold value-text">
                <div
                  :class="
                    $helpers.getStatusClass(
                      currentSampleSummary.status_code
                    )
                  "
                  class="status-text"
                  style="text-align: left"
                >
                  {{ currentSampleSummary.status }}
                </div>
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
      </f7-row>

      <f7-row class="card-body">
        <f7-col>
          <f7-row>
            <f7-col>
              <div class="label-strong">
                {{ $t('environmentSamples.summary.legislation') }}
              </div>
              <div class="item-title-bold value-text">
                {{ currentSampleSummary.legislation }}
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
        <f7-col> </f7-col>
        <f7-col> </f7-col>
        <f7-col></f7-col>
        <f7-col></f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DxButton from 'devextreme-vue/button';
import DxContextMenu from 'devextreme-vue/context-menu';
import ContextMenu from '@/components/contextMenu';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import { downloadReportMixin } from '@/mixins/downloadReportMixin';

export default {
  name: 'MiningSampleSummary',
  components: {
    DxButton,
    DxContextMenu,
    ContextMenu,
  },
  mixins: [downloadReportMixin],
  data() {
    return {
      currentSampleSummary: {},
      loaded: false,
    };
  },
  computed: {
    ...mapState('samples', ['sampleFetchedFromEtl']),
    items() {
      if (this.currentSampleSummary.status_code !== '2') {
        return [
          {
            icon: 'download',
            text: `${this.$t('download')}`,
            onClick: this.download,
            disabled: this.currentSampleSummary.status_code !== '3',
          },
        ];
      }

      return [
        {
          icon: 'refresh',
          text: this.$t('refresh'),
          onClick: this.refresh,
        },
        {
          icon: 'download',
          text: `${this.$t('download')}`,
          onClick: this.download,
          disabled: this.currentSampleSummary.status_code !== '3',
        },
      ];
    },
    getIconPath() {
      return `${
        this.environment === 'development' ? '../../' : './'
      }static/icons/options_burger.svg`;
    },
  },
  async beforeMount() {
    try {
      this.currentSampleSummary =
        await this.getCurrentSampleBasedOnFilter();

      // if (this.currentSampleSummary.status_code == 2) {
      //   this.$notifyDX(
      //     {
      //       message: this.$t('inProcessSampleResult'),
      //       width: 550,
      //     },
      //     'warning',
      //     7000
      //   );
      // }
      if (
        this.currentSampleSummary?.status_code === '2' &&
        this.sampleFetchedFromEtl === false &&
        (
          (
            this.currentSampleSummary?.sample_id !== undefined &&
            this.currentSampleSummary?.sample_id !== null &&
            String(this.currentSampleSummary?.sample_id).trim() !== '' &&
            String(this.currentSampleSummary?.sample_id).trim() !== '0'
          ) ||
          (
            this.currentSampleSummary?.sample_code != null &&
            String(this.currentSampleSummary?.sample_code).trim() !== '' &&
            this.currentSampleSummary?.cod_lim != null &&
            String(this.currentSampleSummary?.cod_lim).trim() !== ''
          )
        )
      ) {
        this.setSampleFetchedFromEtl(true);

        this.loaded = false;
        await this.getSample(this.currentSampleSummary);
        this.loaded = true;

        this.$f7router.navigate(
          { name: 'MiningSamplesDetailsPage' },
          {
            animate: true,
            transition: 'f7-fade',
            reloadCurrent: true,
          }
        );
      }
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }
  },
  methods: {
    async refresh() {
      if (
        this.currentSampleSummary?.status_code === '2' &&
        (
          (
            this.currentSampleSummary?.sample_id !== undefined &&
            this.currentSampleSummary?.sample_id !== null &&
            String(this.currentSampleSummary?.sample_id).trim() !== '' &&
            String(this.currentSampleSummary?.sample_id).trim() !== '0'
          ) ||
          (
            this.currentSampleSummary?.sample_code != null &&
            String(this.currentSampleSummary?.sample_code).trim() !== '' &&
            this.currentSampleSummary?.cod_lim != null &&
            String(this.currentSampleSummary?.cod_lim).trim() !== ''
          )
        )
      ) {
        this.loaded = false;
        await this.getSample(this.currentSampleSummary);
        this.loaded = true;
      }

      this.$f7router.navigate(
        { name: 'MiningSamplesDetailsPage' },
        {
          animate: true,
          transition: 'f7-fade',
          reloadCurrent: true,
        }
      );
    },
    async download(e) {
      this.$notifyDX(
        { message: this.$t('downloading'), width: 350 },
        'info',
        2000
      );

      const { sample_id, study_id, code } = this.currentSampleSummary;
      const downloaded = await this.downloadDualReport({ sample_id, study_id, code });

      if (downloaded) {
        this.$notifyDX(
          { message: this.$t('downloadedFile'), width: 350 },
          'success',
          2000
        );
      } else {
        this.$notifyDX(
          { message: this.$t('sampleHasNoReport'), width: 450 },
          'info',
          2000
        );
      }
    },
    ...mapActions('samples', [
      'getCurrentSampleBasedOnFilter',
      'setSampleFetchedFromEtl',
    ]),
    ...mapActions('riskAnalysis', ['getSample']),
  },
};
</script>

<style scoped>
/* Label (ej: "Código de oferta") */
.label-strong {
  color: var(--Primary-Blue-70, #00346a);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 19.6px */
}

/* Valor (ej: "QCA-ES250900001") */
.value-text {
  color: var(--Neutral-70, #3e3c44);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

.tableContainerDetails {
  padding: 24px !important;
  border-radius: 10px !important;
  background: var(--Neutral-10, #f7f7f8) !important;
  border: 1px solid var(--Neutral-20, #e0e0e0) !important; /* un gris suave para el borde */
}
.status-text {
  background: transparent !important;
  border: none !important;
  margin: auto;
  max-width: 100%;
}
</style>
